import { FC, ReactNode } from 'react';

import { Box } from '../../../box/components/Box/Box';

interface Props {
   children: ReactNode;
   width?: string;
   height?: string;
   direction?: 'row' | 'column';
   shadow?: boolean;
   border?: boolean;
}

/**
 * @deprecated Use Box instead
 */
export const Paper: FC<Props> = ({ children, width, height, direction = 'column', shadow = false, border = true }) => (
   <Box
      spacing="lg"
      borderRadius="largest"
      border={border}
      width={width}
      height={height}
      direction={direction}
      shadow={shadow}
      background="var(--component-surfaces-paper-container-color-background)"
      attributes={{ testid: `paper--${direction}${shadow ? '--shadow' : ''}${border ? '--border' : ''}` }}
   >
      {children}
   </Box>
);
